import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    getWeekTemplates,
    getWeekTemplateById,
    updateWeekTemplate,
    createWeekTemplate,
} from "../fetchers/weekTemplates";
import { fetchMachines } from "../fetchers/machine";
import { assignTemplate, removeAssignedTemplate } from "../fetchers/productionCalendar";

export function useWeekTemplates(companyKey) {
    return useQuery({
        queryKey: ["weekTemplates", companyKey],
        queryFn: () => getWeekTemplates(companyKey),
        enabled: companyKey > 0,
    });
}

export function useWeekTemplate(id) {
    return useQuery({
        queryKey: ["weekTemplate", id],
        queryFn: () => getWeekTemplateById(id),
        enabled: !!id,
    });
}

export function useMachines(companyKey) {
    return useQuery({
        queryKey: ["machines", companyKey],
        queryFn: () => fetchMachines(companyKey),
        enabled: companyKey > 0,
    });
}

export function useUpdateWeekTemplate() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, template }) => updateWeekTemplate(id, template),
        onSuccess: (_data, variables) => {
            qc.invalidateQueries({ queryKey: ["weekTemplate", variables.id] });
            qc.invalidateQueries({ queryKey: ["weekTemplates"] });
        },
    });
}

export function useCreateWeekTemplate() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (template) => {
            const response = await createWeekTemplate(template);
            return response.data;
        },
        onSuccess: (_data, variables) => {
            // invalidiera listan för aktuellt bolag
            if (variables.companyKey) {
                queryClient.invalidateQueries({
                    queryKey: ["weekTemplates", variables.companyKey],
                });
            } else {
                queryClient.invalidateQueries({ queryKey: ["weekTemplates"] });
            }
        },
    });
}

export function useAssignTemplate() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => assignTemplate(body),
        onSuccess: (_data, variables) => {
            qc.invalidateQueries({
                queryKey: ["machineCalendar", variables.machineId],
                exact: false,
            });
        },
    });
}

export function useRemoveAssignedTemplate() {
  return useMutation({
    mutationFn: (body) => removeAssignedTemplate(body),
  });
}